/* esm.sh - @lit/reactive-element@1.6.3/decorators/state */
import{property as r}from"./property.mjs";function o(t){return r({...t,state:!0})}export{o as state};
/*! Bundled license information:

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=state.mjs.map